var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{attrs:{"id":"loginState"}},[_c('b-btn',{attrs:{"variant":"link","size":"sm"},on:{"click":_vm.signOut}},[_vm._v(" "+_vm._s(_vm.roleLinkText)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }